import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["inputs"];
import React, { useState, useEffect } from 'react';
import { CheckboxGroup as CheckboxGroupPoi } from 'hoi-poi-ui';
function CheckboxGroup(_ref) {
  let {
      inputs
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [data, setData] = useState([]);
  useEffect(() => {
    const options = inputs.map(input => ({
      label: input.label,
      value: input.name,
      hint: input.info
    }));
    const isReadOnly = inputs.map(input => input.isReadOnly);
    setData({
      options,
      isReadOnly
    });
  }, [inputs]);
  return /*#__PURE__*/React.createElement(CheckboxGroupPoi, _extends({
    options: data.options
  }, props, {
    isReadOnly: data.isReadOnly,
    isFullWidth: false,
    color: "actionMinor"
  }));
}
export default CheckboxGroup;